//play/pause home header video
document.addEventListener('DOMContentLoaded', function () {
  const homebanner = document.querySelector('.home-banner');

  // Select the video inside it
  let headerVideo = null;
  let playPauseButton = null;
  if (homebanner) {
    headerVideo = homebanner.querySelector('.video__media');
    playPauseButton = homebanner.querySelector('.video__button');
  }

  if (headerVideo && playPauseButton) {
    // Ensure inline playback on iOS Safari
    headerVideo.setAttribute('playsinline', '');
    headerVideo.setAttribute('webkit-playsinline', '');

    // Attempt autoplay (may be blocked by iOS Low Power Mode)
    headerVideo.play().catch(() => {
      playPauseButton.classList.remove('video__button--pause');
      playPauseButton.classList.add('video__button--play');
    });

    // Play/pause video on click on play/pause button
    playPauseButton.addEventListener('click', function () {
      if (!headerVideo.paused) {
        headerVideo.pause();
        playPauseButton.classList.remove('video__button--pause');
        playPauseButton.classList.add('video__button--play');
      } else {
        headerVideo.play();
        playPauseButton.classList.remove('video__button--play');
        playPauseButton.classList.add('video__button--pause');
      }
    });
  }
});
